import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonBlock = ({ additionalStyle = {}, ...props }) => {
  /*
    Generic, customized style
    (Additional, customized style may also be set for a <SkeletonBlock />)
  */
  const genericStyle = {
    marginTop: "15px",
  };

  return (
    <Skeleton style={{ ...genericStyle, ...additionalStyle }} {...props} />
  );
};

SkeletonBlock.propTypes = {
  additionalStyle: PropTypes.object,
};

export default SkeletonBlock;
